(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-hero"] && !Shopify.designMode) return;
  try {
    
  /*
    Logo marquee: vaste snelheid in px/s (ClickUp 124k9qyhk05).

    marquee.js zet de duur van een ronde op wortel(aantal kopieën) x speed-factor,
    los van hoe breed de rij is; met veel of brede logo's liep hij daardoor veel te
    snel. De logo's hebben een vaste hoogte maar geen vaste breedte, dus de afstand
    meten we hier in de browser: één ronde = breedte van de content + de gap (zie
    de keyframes). Een ResizeObserver rekent opnieuw als marquee.js bij een resize
    kopieën toevoegt of weghaalt. Een eigen variabele, zodat marquee.js hem bij het
    opnieuw zetten van --marquee-speed niet overschrijft.
  */
  (() => {
    const setDuration = (component) => {
      const wrapper = component.querySelector('.marquee__wrapper');
      const content = component.querySelector('.marquee__content');
      const pxPerSecond = Number(component.dataset.pxPerSecond);
      if (!wrapper || !content || !pxPerSecond) return;

      const gap = parseFloat(getComputedStyle(wrapper).columnGap) || 0;
      const distance = content.getBoundingClientRect().width + gap;
      if (distance > 0) component.style.setProperty('--custom-marquee-duration', `${distance / pxPerSecond}s`);
    };

    const init = (root = document) => {
      root.querySelectorAll('.custom-hero__marquee-component[data-px-per-second]').forEach((component) => {
        if (component.dataset.pxObserved) return;
        component.dataset.pxObserved = 'true';
        const content = component.querySelector('.marquee__content');
        if (!content) return;
        new ResizeObserver(() => setDuration(component)).observe(content);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-subcategory-pills"] && !Shopify.designMode) return;
  try {
    
  class CustomSubcategoryPills extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('.custom-subcategory-pills__scroller');
      this.arrows = this.querySelectorAll('.custom-subcategory-pills__arrow');
      if (!this.scroller) return;

      this.update = this.update.bind(this);
      this.arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => {
          const direction = Number(arrow.dataset.direction);
          this.scroller.scrollBy({ left: direction * this.scroller.clientWidth * 0.8 });
        });
      });

      this.scroller.addEventListener('scroll', this.update, { passive: true });
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.scroller);
      this.update();
    }

    disconnectedCallback() {
      this.scroller?.removeEventListener('scroll', this.update);
      this.resizeObserver?.disconnect();
    }

    update() {
      const { scrollLeft, scrollWidth, clientWidth } = this.scroller;
      const [prev, next] = this.arrows;
      if (prev) prev.hidden = scrollLeft <= 1;
      if (next) next.hidden = scrollLeft + clientWidth >= scrollWidth - 1;
    }
  }

  if (!customElements.get('custom-subcategory-pills')) {
    customElements.define('custom-subcategory-pills', CustomSubcategoryPills);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-usp-bar"] && !Shopify.designMode) return;
  try {
    
  class CustomUspBar extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.custom-usp-bar__item'));
      if (this.items.length < 2) return;

      this.activeIndex = this.items.findIndex((item) => item.classList.contains('is-active'));
      if (this.activeIndex < 0) this.activeIndex = 0;

      this.interval = parseInt(this.dataset.interval, 10) || 3000;
      this.timer = null;
      this.mobileQuery = window.matchMedia('(max-width: 1099px)');
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.handleQueryChange = this.evaluate.bind(this);

      this.mobileQuery.addEventListener('change', this.handleQueryChange);
      this.motionQuery.addEventListener('change', this.handleQueryChange);

      this.evaluate();
    }

    disconnectedCallback() {
      this.stop();
      this.mobileQuery?.removeEventListener('change', this.handleQueryChange);
      this.motionQuery?.removeEventListener('change', this.handleQueryChange);
    }

    evaluate() {
      const shouldRotate = this.mobileQuery.matches && !this.motionQuery.matches;
      if (shouldRotate) {
        this.start();
      } else {
        this.stop();
      }
    }

    start() {
      if (this.timer) return;
      this.timer = window.setInterval(() => this.showNext(), this.interval);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    showNext() {
      const previous = this.items[this.activeIndex];
      this.items.forEach((item) => item.classList.remove('is-leaving'));
      previous.classList.remove('is-active');
      previous.classList.add('is-leaving');
      this.activeIndex = (this.activeIndex + 1) % this.items.length;
      this.items[this.activeIndex].classList.add('is-active');
    }
  }

  if (!customElements.get('custom-usp-bar')) {
    customElements.define('custom-usp-bar', CustomUspBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
